import PropTypes from "prop-types";
import styles from "./PolicyPage.module.css";

export default function TableOfContents({ entries }) {
  if (!entries || entries.length === 0) return null;

  return (
    <nav aria-label="Table of contents" className={styles.toc}>
      <p className={styles.tocHeading}>Contents</p>
      <ol className={styles.tocList}>
        {entries.map(({ id, text, level }) => (
          <li
            key={id}
            className={level === 3 ? styles.tocItemNested : styles.tocItem}
          >
            <a href={`#${id}`} className={styles.tocLink}>
              {text}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}

TableOfContents.propTypes = {
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      level: PropTypes.number.isRequired,
    }),
  ).isRequired,
};
